export default __webpack_public_path__ + "static/media/OSMOS_TORTORA_MATT_120X120_01.acec011f.jpg";